import "./index.css";
import { jsxs as a, jsx as e } from "react/jsx-runtime";
import { Card as s } from "@design-system/card";
import i from "classnames";

var n = function n(_ref) {
  var n = _ref.className,
      r = _ref.link,
      d = _ref.variant,
      c = _ref.cardContent,
      t = _ref.cardCta,
      l = _ref.cardMedia,
      m = _ref.cardLabel;
  var o = c.headingBlock,
      g = c.disclaimer,
      b = Object.assign(Object.assign({}, o), {
    headlineLink: r
  });
  return a(s, Object.assign({
    className: i("cds-page-card", n),
    hasMedia: !!l,
    variant: d
  }, {
    children: [e(s.CardContent, Object.assign({
      headingBlock: b,
      disclaimer: g
    }, {
      children: t && e(s.CardCTA, Object.assign({}, t))
    })), l || m ? e(s.CardMedia, Object.assign({}, "standard" === d ? {
      mediaVariant: "rounded"
    } : {}, l, {
      children: m && e(s.CardLabel, Object.assign({}, m))
    })) : null]
  }));
};

export { n as PageCard };